import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UbsViewContainersModule } from '@urbannex/view-containers';
import { ConfigurationRoutingModule } from './configuration-routing.module';
import { ConfigurationsComponent } from './configurations.component';
import { NbMenuModule } from '@nebular/theme';


@NgModule({
  declarations: [ConfigurationsComponent],
  imports: [
    CommonModule,
    UbsViewContainersModule,
    ConfigurationRoutingModule,
    NbMenuModule
  ],
  exports:[
    ConfigurationRoutingModule
  ]
})
export class ConfigurationsModule { }
